export default __webpack_public_path__ + "static/media/regulatory--one-way-straight--g3.01f68d4b.png";